import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

export function useIsVisibleOrBelow(ref?: RefObject<Element>, threshold: number = 1.0) {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIntersecting(true);
                } else {
                    if (entry.boundingClientRect.top > 0) {
                        setIntersecting(false);
                    } else {
                        setIntersecting(true);
                    }
                }
            },
            { rootMargin: '0px', threshold: threshold },
        );
        if (ref && ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [ref, threshold]);

    return isIntersecting;
}
